// extracted by mini-css-extract-plugin
export default {"productThumbnails":"jW-z","zoomMode":"kW-z","carousel":"lW-z","slides":"mW-z","slide":"nW-z","slideThumb":"oW-z","nav":"pW-z","fadeIn":"qW-z","mounting":"rW-z","horizontal":"sW-z"};